import { activityAboutSchema } from './activityAbout.js'

export const transportAboutSchema = {
  ...activityAboutSchema(false)
}
